import qs from 'qs'
import axios from 'axios'
import { Message } from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 600000, // 请求超时时间 response 会返回 errError: timeout of 1000ms exceeded
  withCredentials: true
})

// request 拦截器
service.interceptors.request.use(
  config => {
    if (config.method.toLowerCase() === 'post') {
      // 没有传 Content-Type，设置认为是 application/x-www-form-urlencoded 且将 config.data 转换为合法的格式
      if (!config.headers['Content-Type']) {
        config.data = qs.stringify(config.data)
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      } else {
        if (
          config.headers['Content-Type'].indexOf('multipart/form-data') === 0
        ) {
          const data = new FormData()
          for (const i in config.data) {
            data.append(i, config.data[i])
          }
          config.data = data
        }
      }
    }

    return config
  },

  error => {
    return Promise.reject(error)
  }
)

// respone 拦截器
service.interceptors.response.use(
  res => {
    return res
  },

  error => {
    Message({
      message: error.message || '网络异常，请稍后重试！',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service

